export default "__VITE_ASSET__D8NlBx5Z__"